import { render, staticRenderFns } from "./SaveReportWizardUMR.vue?vue&type=template&id=8db122e4"
import script from "./SaveReportWizardUMR.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardUMR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports